import PropTypes from 'prop-types';

import getToday from '@helpers/Date/getToday';

import participantDefault from './participantDefault';
import retrospectiveDefault from './retrospectiveDefault';

const noteDefault = {
  id: null,
  content: '',
  author: '',
  retrospective: null,
  groupWord: '',
  date: getToday(),
  isPublic: true,
  hasFiles: false,
  rate: 0,
  myVotes: 0,
  totalVotes: 0,
  question: null
};

const notePropType = PropTypes.shape({
  id: PropTypes.string,
  content: PropTypes.string,
  author: PropTypes.string,
  retrospective: PropTypes.string,
  date: PropTypes.string,
  groupWord: PropTypes.string,
  isPublic: PropTypes.bool,
  rate: PropTypes.number,
  myVotes: PropTypes.number,
  totalVotes: PropTypes.number,
  question: PropTypes.string,
  hasFiles: PropTypes.bool
});

const actionDefault = {
  id: null,
  responsible: [],
  description: '',
  date: getToday(),
  isInLastActionList: false,
  isDone: false,
  notes: []
};

const actionPropType = PropTypes.shape({
  id: PropTypes.string,
  responsible: PropTypes.arrayOf(PropTypes.string),
  description: PropTypes.string,
  date: PropTypes.string,
  isDone: PropTypes.bool,
  isInLastActionList: PropTypes.bool,
  notes: PropTypes.arrayOf(notePropType)
});

const participantPropType = PropTypes.shape({
  id: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  color: PropTypes.string,
  avatar: PropTypes.instanceOf(File),
  isGuestUser: PropTypes.bool
});

const methodsPropType = PropTypes.shape({
  modules: PropTypes.arrayOf(PropTypes.string),
  gatherViewMethod: PropTypes.string,
  lastActionList: PropTypes.shape({
    id: PropTypes.string,
    method: PropTypes.string
  })
});

const retrospectivePropType = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  category: PropTypes.string,
  voteUserMax: PropTypes.number,
  participants: PropTypes.arrayOf(participantPropType),
  color: PropTypes.string,
  methods: methodsPropType,
  linkHash: PropTypes.string,
  users: PropTypes.arrayOf(participantPropType),
  teams: PropTypes.arrayOf(PropTypes.string)
});

const teamPropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  myRole: PropTypes.string,
  teamInviteCode: PropTypes.string,
  users: PropTypes.arrayOf(participantPropType),
  facilitators: PropTypes.arrayOf(PropTypes.string),
  invitations: PropTypes.arrayOf(
    PropTypes.shape({
      isFacilitator: PropTypes.bool,
      user: participantPropType
    })
  )
});

const orgPropType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  contactFirst: PropTypes.string,
  contactLast: PropTypes.string,
  mail: PropTypes.string,
  users: PropTypes.arrayOf(participantPropType),
  admins: PropTypes.arrayOf(PropTypes.string)
});

export {
  retrospectiveDefault,
  retrospectivePropType,
  actionDefault,
  actionPropType,
  noteDefault,
  notePropType,
  participantPropType,
  participantDefault,
  teamPropType,
  orgPropType
};
